import React from "react";
import useThirdPartyCookieSupport from "../../hooks/useThirdPartyCookieSupport";

export default function ThirdPartyCookieInfo() {
  const thirdPartyCookiesAllowed = useThirdPartyCookieSupport();
  return (
    <>
      {!thirdPartyCookiesAllowed && (
        <div className="bg-yellow-100 border border-yellow-300 text-yellow-800 p-4 mb-4 text-sm">
          ⚠️ <strong>Third-party cookies are disabled in your browser.</strong>
          <br />
          <br />
          Please enable third-party cookies in your browser settings to ensure full functionality.
          <p className="mt-2 text-xs text-blue-700 underline">
            <a
              href="https://www.whatismybrowser.com/guides/how-to-enable-cookies/auto"
              target="_blank"
              rel="noopener noreferrer"
            >
              Learn how to enable cookies in your browser
            </a>
          </p>
        </div>
      )}
    </>
  );
}
